var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.69629C0 4.405 0.82629 3.25858 2.05132 2.85024L8.05131 0.85024C8.66711 0.644973 9.33288 0.644972 9.94868 0.850239L15.9487 2.85024C17.1737 3.25858 18 4.405 18 5.69629V11.034C18 16.536 12.4398 19.8757 10.0601 21.0532C9.38748 21.3859 8.61252 21.3859 7.93993 21.0532C5.56019 19.8757 0 16.536 0 11.034V5.69629ZM12 8.03406C12 9.69091 10.6569 11.0341 9 11.0341C7.34315 11.0341 6 9.69091 6 8.03406C6 6.3772 7.34315 5.03406 9 5.03406C10.6569 5.03406 12 6.3772 12 8.03406ZM9.00003 13.0341C10.7944 13.0341 12.431 13.7092 13.6698 14.8193C14.0352 15.1467 14.0409 15.7051 13.6998 16.0576C13.6392 16.1201 13.5779 16.1822 13.5157 16.2437C12.0429 17.7011 10.2698 18.718 9.17318 19.2606C9.05954 19.3168 8.94053 19.3168 8.82688 19.2606C7.73031 18.718 5.95721 17.7011 4.48435 16.2437C4.42218 16.1822 4.36082 16.1201 4.30031 16.0576C3.95912 15.7051 3.96487 15.1467 4.33023 14.8193C5.56904 13.7092 7.20569 13.0341 9.00003 13.0341Z",
    fill: "#6F767E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/Customer_Icon.7d8f94bb62fa6028be22a5e7f3320dcc.svg";
export { ForwardRef as ReactComponent };